<template>
    <v-card
        @click="openProfile()"
        class="profile-card"
        elevation="0"
    >
        <v-card-text class="pa-0 pa-md-3">
            <h2 class="text-h5 mb-4 primary--text">
                <v-avatar
                    class="mr-2"
                    size="48"
                    v-if="profile.image"
                >
                  <img
                    :src="profile.image.url"
                    :alt="profile.name"
                  >
                </v-avatar>
                {{ profile.name }}
            </h2>
            <v-row class="align-start my-0 pb-4">
                <v-col class="col-12 col-md-6 py-0 mb-4 mb-md-0">
                    <p class="mb-0">{{ profile.summary }}</p>
                </v-col>
                <v-col class="col-9 col-md-4 py-0">
                    <ul class="list-unstyled details">
                        <li class="mb-2">
                            <v-icon
                                small
                                color="secondary"
                                class="mr-1 fa-fw"
                            >
                                far fa-map-marker-alt
                            </v-icon>
                            {{ profile.city }}
                        </li>
                        <li class="mb-2">
                            <v-icon
                                small
                                color="secondary"
                                class="mr-1 fa-fw"
                            >
                                far fa-calendar-day
                            </v-icon>
                            {{ profile.dateOfBirth|luxon }}
                        </li>
                        <li class="mb-2">
                            <v-icon
                                small
                                color="secondary"
                                class="mr-1 fa-fw"
                            >
                                far fa-envelope
                            </v-icon>
                            {{ profile.email }}
                        </li>
                        <li class="mb-2">
                            <v-icon
                                small
                                color="secondary"
                                class="mr-1 fa-fw"
                            >
                                far fa-phone
                            </v-icon>
                            {{ profile.phoneNumber }}
                        </li>
                    </ul>
                </v-col>
                <v-col class="col-3 col-md-2 py-0 my-auto text-right">
                    <v-btn
                        fab
                        color="primary"
                        dark
                        elevation="0"
                    >
                        <v-icon>
                            fas fa-angle-double-right
                        </v-icon>
                    </v-btn>
                </v-col>
            </v-row>
            <p class="text--secondary">
                <v-icon
                    small
                    color="secondary"
                    class="mr-1 fa-fw"
                >
                    far fa-clock
                </v-icon>
                {{ profile.createdAt|luxon }}
            </p>
        </v-card-text>
    </v-card>
</template>

<script>
export default {
    name: "ProfileCard",
    props: {
        profile: {
            type: Object,
            required: true,
        },
    },
    methods: {
        openProfile () {
            this.$router.push({name: 'Profile', params: { uuid: this.profile.uuid }});
        },
    },
}
</script>

<style scoped>

</style>
